import { Badge, Col, Row } from "reactstrap";
import {
    ThirdPartyDocumentCategories,
    ThirdPartyDocumentConfidentialityLevels,
    ThirdPartyDocumentTypes
} from "src/modules/3rd-party-management/constants";

const optionTitle = (options, value) => (
    options.find((option) => option.value === value)?.title || value
);

const formatFileSize = (bytes) => {
    const size = Number(bytes);

    if (!Number.isFinite(size) || size <= 0) {
        return null;
    }

    if (size < 1024) {
        return `${size} B`;
    }

    if (size < 1024 * 1024) {
        return `${(size / 1024).toFixed(1)} KB`;
    }

    return `${(size / (1024 * 1024)).toFixed(1)} MB`;
};

const legalEntityNames = (document) => {
    if (document.is_all_entities || document.isAllEntities) {
        return 'All legal entities';
    }

    const entities = document.legalEntities || document.legal_entities || [];

    return entities
        .map((entity) => entity.title || entity.name || entity.label)
        .filter(Boolean)
        .join(', ');
};

const ConfirmationDocumentItem = ({ t, document, status }) => {
    const isLink = (document.content_type || document.contentType) === "link";
    const fileName = document.name || document.originName || document.origin_name;
    const fileSize = formatFileSize(document.size);
    const entities = legalEntityNames(document);

    const fields = [
        {
            label: 'Category',
            value: document.category && t(optionTitle(ThirdPartyDocumentCategories, document.category))
        },
        {
            label: 'Type',
            value: document.type && t(optionTitle(ThirdPartyDocumentTypes, document.type))
        },
        {
            label: 'Confidentiality Level',
            value: document.confidentialityLevel
                && t(optionTitle(ThirdPartyDocumentConfidentialityLevels, document.confidentialityLevel))
        },
        ...(entities ? [{
            label: 'Legal Entities',
            value: t(entities)
        }] : [])
    ];

    return (
        <div className="border rounded p-3 h-100">
            <div className="d-flex justify-content-between align-items-start mb-3">
                <div className="d-flex align-items-start" style={{ minWidth: 0 }}>
                    <i
                        className={`${isLink ? 'ri-link' : 'ri-file-text-line'} font-size-22 text-primary me-2`}
                    />
                    <div style={{ minWidth: 0 }}>
                        <h6 className="mb-1 text-break">
                            {document.title || fileName || '---'}
                        </h6>
                        <small className="text-muted text-break d-block">
                            {isLink ? (
                                document.path ? (
                                    <a href={document.path} target="_blank" rel="noopener noreferrer">
                                        {document.path}
                                    </a>
                                ) : '---'
                            ) : (
                                <>
                                    {fileName || '---'}
                                    {fileSize && ` · ${fileSize}`}
                                </>
                            )}
                        </small>
                    </div>
                </div>

                {status && (
                    <Badge color={status.color} pill className="ms-2 flex-shrink-0">
                        {t(status.label)}
                    </Badge>
                )}
            </div>

            <Row>
                {fields.map((field) => (
                    <Col sm="12" md="6" key={field.label}>
                        <p>
                            <strong>{t(field.label)}:</strong><br />
                            {field.value || '---'}
                        </p>
                    </Col>
                ))}

                {document.description && (
                    <Col sm="12">
                        <p className="mb-0">
                            <strong>{t('Description')}:</strong><br />
                            <span className="text-break">{document.description}</span>
                        </p>
                    </Col>
                )}
            </Row>
        </div>
    );
};

export default ConfirmationDocumentItem;
